import axios from 'axios';

// MVK-3905 — đăng nhập bằng modal (#loginModalForm trong #userModal), tách khỏi `app.js`. Đóng modal qua adapter nên chạy được
// trên cả trang Bootstrap lẫn Flowbite.
//
// Hook trung lập, không gắn với class của thư viện nào: hộp lỗi là `#userModal [data-login-error]` (chữ ghi vào con
// `[data-login-error-text]` nếu có, không thì vào chính hộp), nút gửi là `[data-login-submit]`. Class ẩn hộp lỗi do entry
// truyền vào: `app.js` truyền `d-none` (Bootstrap), `web.js` truyền `hidden` (Tailwind).
function setModalAlertText(hiddenClass, message) {
    const alertElement = document.querySelector('#userModal [data-login-error]');
    if (!alertElement) {
        return;
    }

    const textElement = alertElement.querySelector('[data-login-error-text]') ?? alertElement;

    if (message) {
        alertElement.classList.remove(hiddenClass);
        textElement.textContent = message;
        return;
    }

    alertElement.classList.add(hiddenClass);
    textElement.textContent = '';
}

/**
 * Không có form (trang không nhúng modal đăng nhập) thì không làm gì.
 *
 * @param {{hide: Function}} modal adapter (shared/modal/*)
 * @param {string} hiddenClass class ẩn hộp lỗi của markup đang dùng (`d-none` | `hidden`)
 */
export function initLoginModal(modal, hiddenClass) {
    const loginModalForm = document.getElementById('loginModalForm');
    if (!loginModalForm || loginModalForm.dataset.loginFormSubmitBound === 'true') {
        return;
    }

    loginModalForm.dataset.loginFormSubmitBound = 'true';

    loginModalForm.addEventListener('submit', function(event) {
        event.preventDefault();

        const submitButton = loginModalForm.querySelector('[data-login-submit]');
        const submitButtonHtml = submitButton ? submitButton.innerHTML : null;

        if (submitButton) {
            submitButton.innerHTML = 'Đăng nhập...';
            submitButton.setAttribute('disabled', 'disabled');
            submitButton.classList.add('disabled');
        }

        axios.post(loginModalForm.action, new URLSearchParams(new FormData(loginModalForm)), {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        }).then(function(response) {
            const responseText = response.data;

            if (responseText.status == 'success') {
                setModalAlertText(hiddenClass, '');
                const userModal = document.getElementById('userModal');
                if (userModal) {
                    modal.hide(userModal);
                }
                window.location.reload();
                return;
            }

            setModalAlertText(hiddenClass, responseText.message);

            if (submitButton && submitButtonHtml !== null) {
                submitButton.innerHTML = submitButtonHtml;
                submitButton.removeAttribute('disabled');
                submitButton.classList.remove('disabled');
            }
        }).catch(function() {
            setModalAlertText(hiddenClass, 'Có lỗi xảy ra, vui lòng thử lại.');

            if (submitButton && submitButtonHtml !== null) {
                submitButton.innerHTML = submitButtonHtml;
                submitButton.removeAttribute('disabled');
                submitButton.classList.remove('disabled');
            }
        });
    });
}
